import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Link as RouterLink } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ArrowForwardIcon from 'components/material-symbol/icons/ArrowForward'
import { useRoleCardStyles } from './welcome-role-card.styles'

const WelcomeRoleCard = ({
  testid,
  to,
  audience,
  roleTitle,
  intro,
  headerIcon,
  headerImage,
  headerImageAlt = '',
  features,
  continueLabel,
}) => {
  const classes = useRoleCardStyles()

  return (
    <Box
      className={classes.card}
      component={RouterLink}
      to={to}
      data-testid={testid}
      aria-label={continueLabel}
    >
      {headerImage ? (
        <Box className={classes.headerShell}>
          <Box
            className={classes.headerImageArea}
            style={{ backgroundImage: `url(${headerImage})` }}
            {...(headerImageAlt
              ? { role: 'img', 'aria-label': headerImageAlt }
              : { 'aria-hidden': true })}
          />
          <Box className={classes.headerMeta}>
            <Typography className={classes.audience} component="p">
              {audience}
            </Typography>
            <Typography className={classes.roleTitle} component="h2">
              {roleTitle}
            </Typography>
          </Box>
          {headerIcon && (
            <Box className={classes.iconTileOverlay}>{headerIcon}</Box>
          )}
        </Box>
      ) : (
        <Box className={classes.header}>
          {headerIcon && <Box className={classes.iconTile}>{headerIcon}</Box>}
          <Typography className={classes.audience} component="p">
            {audience}
          </Typography>
          <Typography className={classes.roleTitle} component="h2">
            {roleTitle}
          </Typography>
        </Box>
      )}

      <Box
        className={clsx(
          classes.body,
          headerImage && classes.bodyWithHeaderImage,
        )}
      >
        <Typography className={classes.intro} component="p">
          {intro}
        </Typography>

        <Box className={classes.featureList} component="ul">
          {features.map(({ key, icon, text }) => (
            <Box key={key} className={classes.featureRow} component="li">
              <span className={classes.featureIconWrap}>{icon}</span>
              <Typography className={classes.featureText} component="p">
                {text}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box
          className={classes.continueButton}
          component="span"
          aria-hidden="true"
        >
          <Typography className={classes.continueLabel} component="span">
            {continueLabel}
          </Typography>
          <ArrowForwardIcon />
        </Box>
      </Box>
    </Box>
  )
}

WelcomeRoleCard.propTypes = {
  testid: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  audience: PropTypes.string.isRequired,
  roleTitle: PropTypes.string.isRequired,
  intro: PropTypes.string.isRequired,
  headerIcon: PropTypes.element,
  headerImage: PropTypes.string,
  headerImageAlt: PropTypes.string,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      icon: PropTypes.element.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  continueLabel: PropTypes.string.isRequired,
}

export default WelcomeRoleCard
